import {Navigate, Route, Routes} from 'react-router';
import PageLayout from './layout/PageLayout';
import CustomerListPage from './components/pages/CustomerListPage';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';
import Command from './state/actions/command';
import DashboardPage from './components/pages/DashboardPage';
import ProjectDetailsPage from './components/pages/ProjectDetailsPage';
import {Selector} from './state/selector';

const Main = () => {
    const dispatch = useDispatch();
    const isAdmin = useSelector(Selector.User.isAdmin);

    useEffect(() => {
        dispatch(Command.Customer.fetchCustomerList({}));
        dispatch(Command.WorkingTime.fetchAllWorkingTimeList({}));
    }, []);

    return (
        <Routes>
            <Route path={'/'} element={<PageLayout />}>
                {isAdmin && <Route path={'/dashboard'} element={<DashboardPage />} />}
                <Route path={'/customers'} element={<CustomerListPage />} />
                <Route path={'/customers/:customerId/projects/:projectId'} element={<ProjectDetailsPage />} />
                <Route index={true} element={<Navigate to={'/customers'} replace={true} />} />
            </Route>
        </Routes>
    );
};

export default Main;
